<div class="container-div">
  <div class="header-div">
    <span class="main-header-text">
      Welcome to
      Satsang Philanthropy
    </span>
    <span class="sub-header-text">
      Upon Sign in, you’ll be redirected to Satsang SSO. Use your email/family code to log in. If you want to generate
      F.C., please register!
    </span>
  </div>
  <div class="body-div">
    <button class="sat-primary-btn" style="justify-content: center;" (click)="onLoginClick()">Sign in</button>
    <button class="sat-primary-btn" style="justify-content: center;
    background-color: transparent !important;
    color: var(--brand-primary) !important;" (click)="onRegisterClick()">No Account? Register Now</button>
  </div>
</div>